import React from 'react';

import classNames from 'classnames';

import { ExternalLink } from '../ExternalLink';
import { EXTERNAL_LINK, LINK_REDIRECTION_QUERY } from './constants';

import styles from './styles.module.scss';

export const LoginButton: React.FC<sharedComponents.LoginButton> = ({
  text = 'Login',
  url = `${EXTERNAL_LINK}${LINK_REDIRECTION_QUERY}`,
  target,
  className,
}) => (
  <ExternalLink
    text={text}
    link={url}
    withIcon={false}
    className={classNames(styles.loginButton, className)}
    target={target}
    analytics={text}
  />
);
